import { ReportEventDataEvent } from "../types";
import { getAnalyticsReport } from "./store";

export const handleReport = ({ platform, measurementId, data }: ReportEventDataEvent) => {
  const report = getAnalyticsReport(platform, measurementId);

  if (!report) {
    window.console.error('No report function for: ', platform, measurementId);
    return;
  }

  report(...data);
}